<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Account' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label>{{'Email address' | translate}}*</label>
      <input class="form-control" [(ngModel)]="entity.emailAddress">
    </div>

    <div class="form-group">
      <label>{{'First name' | translate}}</label>
      <input class="form-control" [(ngModel)]="entity.firstName">
    </div>

    <div class="form-group">
      <label>{{'Last name' | translate}}</label>
      <input class="form-control" [(ngModel)]="entity.lastName">
    </div>

    <div class="form-group">
      <label>{{'Phone number' | translate}}</label>
      <input class="form-control" [(ngModel)]="entity.phoneNumber">
    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close(false)">{{'Cancel' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="Save()">
        <fa-icon *ngIf="isProcessing" [icon]="faSpinner" animation="spin"></fa-icon>
        {{'Save' | translate}}
      </button>
    </div>
  </div>
</div>
